// extracted by mini-css-extract-plugin
export default {"container":"sX-z","title":"tX-z","link":"uX-z"};